import type { IEventItem } from '@op/components/ChartsEvents/types';
import { LANGUAGE_EN } from '@home/_config/config';
import { resolveOpinionLineChartEventTypeKey } from '../../utils/eventTypeStyle';

/** 分组 key 对应的中文展示名（与 event_type 一致，勿用首条 event_type_cn） */
export const OPINION_EVENT_CATEGORY_CN: Record<string, string> = {
  Others: '其他',
  others: '其他',
  Holiday: '节假日',
  holiday: '节假日',
  season_pass: '赛季通行证',
  'In-game Events': '游戏内活动',
  ingame_event: '游戏内活动',
  crisis: '舆情事件',
  Promo: '付费/促销',
  monetization: '商业化',
  version_release: '版本发布',
  Version: '版本',
  esports: '电竞赛事',
  marketing_campaign: '营销活动',
  'Marketing Events': '营销事件',
  community: '社区运营',
  maintenance: '停服维护',
  beta_test: '测试服',
  observance: '纪念日',
  Anniversary: '周年庆',
  bank: '储蓄活动',
  unknown: '未知',
  'Player Discussions': '玩家讨论',
  Announcement: '公告',
  'Game Show': '游戏展',
  regional: '区域',
  collab: 'IP 联动',
  public: '公开',
};

/** 分组 key 对应英文展示名 */
export const OPINION_EVENT_TYPE_LABEL_EN: Record<string, string> = {
  Others: 'Others',
  others: 'Others',
  Holiday: 'Holiday',
  holiday: 'Holiday',
  season_pass: 'Season Pass',
  'In-game Events': 'In-game Events',
  ingame_event: 'In-game Event',
  crisis: 'Crisis',
  Promo: 'Promo',
  monetization: 'Monetization',
  version_release: 'Version Release',
  Version: 'Version',
  esports: 'Esports',
  marketing_campaign: 'Marketing Campaign',
  'Marketing Events': 'Marketing Events',
  community: 'Community Ops',
  maintenance: 'Maintenance',
  beta_test: 'Beta Test',
  observance: 'Observance',
  Anniversary: 'Anniversary',
  bank: 'Bank',
  unknown: 'Unknown',
  'Player Discussions': 'Player Discussions',
  Announcement: 'Announcement',
  'Game Show': 'Game Show',
  regional: 'Regional',
  collab: 'IP Collaboration',
  public: 'Public',
};

/** 事件类型展示文案：优先本地配置，API event_type_cn 仅作兜底 */
export function getOpinionEventTypeDisplayName(
  eventType?: string,
  lang?: string,
  fallbackFromApi?: string,
): string {
  const key = resolveOpinionLineChartEventTypeKey(eventType);
  const isEn = lang === LANGUAGE_EN;

  if (isEn) {
    return (
      OPINION_EVENT_TYPE_LABEL_EN[key] ||
      fallbackFromApi ||
      eventType ||
      key
    );
  }

  return (
    OPINION_EVENT_CATEGORY_CN[key] ||
    fallbackFromApi ||
    OPINION_EVENT_TYPE_LABEL_EN[key] ||
    eventType ||
    key
  );
}

/** 分组 key 对应展示名（name 为内部 type key，展示文案在渲染时用 getOpinionEventTypeDisplayName） */
export function getOpinionEventCategoryMeta(
  categoryKey: string,
  list: IEventItem[],
): { name: string; name_cn: string } {
  const matchedItem = list.find(item => item.event_type === categoryKey);
  const fallbackCn = matchedItem?.event_type_cn;

  return {
    name: categoryKey,
    name_cn: getOpinionEventTypeDisplayName(
      categoryKey,
      'zh-CN',
      fallbackCn,
    ),
  };
}
